// URL pattern mapping configuration
export const URL_PATTERNS = {
  'azure-backoffice-frontend': (tenant) => `${tenant}-scus-app-backoffice.azurewebsites.net`,
  'azure-storefront-frontend': (tenant) => `${tenant}-scus-app-auction.azurewebsites.net`,
  'azure-simulcast-frontend': (tenant) => `${tenant}-auction-simulcast.azurewebsites.net`,
  'backend-backoffice-api': (tenant) => `${tenant}-scus-app-api.azurewebsites.net`,
  'backend-auctionengine': (tenant) => `${tenant}-scus-app-auctionengine.azurewebsites.net`,
  'backend-simulcast-api': (tenant) => `${tenant}-simulcast-api.azurewebsites.net`,
  'backend-simulcast-auctionengine': (tenant) => `${tenant}-simulcast-auctionengine.azurewebsites.net`,
  'backend-company-api': (tenant) => `${tenant}-company-api.azurewebsites.net`,
  'backend-contacts-api': (tenant) => `${tenant}-contacts-api.azurewebsites.net`,
  'backend-inventory-api': (tenant) => `${tenant}-inventory-api.azurewebsites.net`,
  'azure-kiosk': (tenant) => `${tenant}-kiosk.platformhost.app`,
  'platformhost-backoffice': (tenant) => `${tenant}.platformhost.app`,
  'platformhost-storefront': (tenant) => `${tenant}-storefront.platformhost.app`,
  'platformhost-simulcast': (tenant) => `${tenant}-auction.platformhost.app`,
  'innova-go': () => 'go.innovallc.com',
  'innova-go-uat': () => 'go-uat.innovallc.com',
  'localhost': () => 'localhost:3000',
};

// Projects that need CORS generation
export const BACKEND_PROJECTS = [
  { id: 'backend-backoffice-api', name: 'Backend Backoffice API' },
  { id: 'backend-auctionengine', name: 'Backend Auction Engine' },
  { id: 'backend-simulcast-api', name: 'Backend Simulcast API' },
  { id: 'backend-simulcast-auctionengine', name: 'Backend Simulcast Auction Engine' },
  { id: 'backend-company-api', name: 'Backend Company API' },
  { id: 'backend-contacts-api', name: 'Backend Contacts API' },
  { id: 'backend-inventory-api', name: 'Backend Inventory API' },
];

// Maps API ID -> resource group suffix (appended to tenant name with a hyphen)
// For unified-RG tenants, use getResourceGroupForApi() instead of this map directly.
export const API_RESOURCE_GROUP_MAP = {
  'backend-backoffice-api': 'rsg-prod',
  'backend-auctionengine': 'rsg-prod',
  'backend-simulcast-api': 'simulcast',
  'backend-simulcast-auctionengine': 'simulcast',
  'backend-company-api': 'rsg-prod',
  'backend-contacts-api': 'rsg-prod',
  'backend-inventory-api': 'rsg-prod',
};

// New tenants use a unified resource group (everything in {tenant}-rsg-prod).
// This helper returns the correct RG name based on whether the tenant uses unified or legacy RG.
export const getResourceGroupForApi = (tenant, apiId, useUnifiedRG = false) => {
  if (useUnifiedRG) {
    return `${tenant}-rsg-prod`;
  }
  const suffix = API_RESOURCE_GROUP_MAP[apiId];
  return suffix ? `${tenant}-${suffix}` : `${tenant}-rsg-prod`;
};

// Maps API ID -> Azure App Service name (without .azurewebsites.net)
export const APP_SERVICE_NAMES = {
  'backend-backoffice-api': (tenant) => `${tenant}-scus-app-api`,
  'backend-auctionengine': (tenant) => `${tenant}-scus-app-auctionengine`,
  'backend-simulcast-api': (tenant) => `${tenant}-simulcast-api`,
  'backend-simulcast-auctionengine': (tenant) => `${tenant}-simulcast-auctionengine`,
  'backend-company-api': (tenant) => `${tenant}-company-api`,
  'backend-contacts-api': (tenant) => `${tenant}-contacts-api`,
  'backend-inventory-api': (tenant) => `${tenant}-inventory-api`,
};
